import React from "react";
import micBlocked from "../../assets/mic_blocked.png";
import lightbulbIcon from "../../assets/lightbulb_orange.svg";

interface MicrophoneErrorModalProps {
  isOpen: boolean;
  onClose: () => void;
  onRetry: () => void;
}

const MicrophoneErrorModal: React.FC<MicrophoneErrorModalProps> = ({ isOpen, onClose, onRetry }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[100]">
      <div className="relative bg-white rounded-lg shadow-xl max-w-md w-full mx-4 overflow-hidden">
        <button
          className="absolute top-3 right-3 text-gray-600 hover:text-gray-800 transition-colors"
          onClick={onClose}
          aria-label="Close"
          type="button"
        >
          <svg className="h-6 w-6 fill-current" viewBox="0 0 24 24">
            <path
              d="M6 18L18 6M6 6l12 12"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>

        <div className="flex items-center justify-center px-10 pt-11 bg-gradient-to-b from-[#D5D5FF] to-[#C8C8F0]">
          <img src={micBlocked} alt="microphone blocked" />
        </div>

        <div className="text-body space-y-[32px] p-8">
          <div className="space-y-[20px]">
            <div>
              <h2 className="text-grey-7 font-ubuntu text-[24px] font-medium leading-[38.4px]">
                Microphone Access Required
              </h2>
            </div>

            <div className="space-y-2">
              <p className="text-grey-7 font-ubuntu text-[16px] font-normal leading-[24px]">
                To test your microphone
              </p>
              <p className="text-grey-7 font-ubuntu text-[16px] font-normal leading-[24px]">
                Please check your microphone permissions and try again.
              </p>
            </div>
          </div>

          <div className="flex items-center gap-2 text-[16px] font-normal leading-[21px] text-[#00143D] bg-[#FFF6E5] rounded-lg p-2">
            <span>
              <img src={lightbulbIcon} alt="lightbulb" className="w-5 h-5" />
            </span>
            Without microphone access, we can't test your audio.
          </div>

          <div className="flex items-center justify-center">
            <button className="text-button bg-button text-white px-4 py-2 rounded w-full" onClick={onRetry} type="button">
              Try Again
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MicrophoneErrorModal;
